import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  paperStyle: {
    padding: '6px',
    marginBottom: '10px',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  tabs: {
    fontSize: 12,
    height: 30,
    boxShadow: '0 0px 0px 0px rgba(255, 105, 135, .3)',
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    marginRight: 0,
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    minWidth: 120,
  },
  appBar: {
    backgroundColor: theme.palette.white.main,
    position: 'absolute',
  },
  dialogTitle: {
    backgroundColor: theme.palette.white.main,
    marginTop: 16,
    paddingTop: 0,
  },
  dialogContent: {
    // background: 'linear-gradient(to bottom, white 97.5px, #e3e5e6 0%)',
    backgroundColor: theme.palette.constrastGreyNormal.main,
    minHeight: '80vh',
    overflow: 'none',
  },
  dialogActions: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  tabSelected: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
    color: theme.palette.primary.main,
  },
  tabNotSelected: {
    backgroundColor: theme.palette.white.main,
    color: theme.palette.secondary.main,
  },
  chip: {
    backgroundColor: theme.palette.white.main,
  },
  tabPanel: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  tabBackground: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
    position: 'relative',
    minHeight: 700,
    width: '100%',
  },
  pointer: {
    cursor: 'pointer',
  },
  downloadModal: {
    width: 400,
  },
  downloadModalContent: {
    color: '#fff',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  downloadButton: {
    backgroundColor: 'rgb(62,67,69)',
    textAlign: 'center',
  },
  gridIconButton: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  errorRoot: {
    height: 'auto',
  },
  errorContainer: {
    width: '100%',
    border: '1px solid #cccccc',
    height: 'auto',
    marginTop: 20,
  },
  errorModal: {
    background: 'linear-gradient(to bottom, red 97.5px, #e3e5e6 0%)',
    overflow: 'none',
  },
  errorAppBar: {
    height: 40,
    width: '100%',
    backgroundColor: 'rgb(138,138,138)',
    verticalAlign: 'middle',
    position: 'relative',
  },
  errorTitle: {
    color: 'white',
    fontSize: 20,
    marginLeft: 10,
    paddingTop: 5,
    textAlign: 'center',
  },
  errorButton: {
    backgroundColor: 'rgb(62,67,69)',
    textAlign: 'center',
  },
  lineBreak: {
    whiteSpace: 'pre-line',
  },
}));

export const useChipStyles = makeStyles({
  root: {
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    '& fieldset': {
      border: 0,
    },
  },
  inputRoot: {
    maxHeight: '220px',
    overflowY: 'scroll',
  },
});

export default styles;
